import AboutUsIntroBlueLeft from '@assets/images/aboutUsIntroBlueLeft.png';
import AboutUsIntroBottom from '@assets/images/aboutUsIntroBottom.png';
import AboutUsIntroOrangeRight from '@assets/images/aboutUsIntroOrangeRight.png';
import Image from 'next/image';
import { SEOLayout } from '@layouts';
import styles from './styles.module.scss';

const AboutUs = () => (
  <SEOLayout
    title="About"
    description="Discover PerksBar, a dynamic platform fostering connections between employees, managers, and organizations through a gamified ecosystem. Explore our commitment to innovation and synergy between creativity and technology."
  >
    <div className={styles.infoContainer}>
      {/* Background Image */}
      <Image className={styles.aboutUsIntroBlueLeft} alt="" src={AboutUsIntroBlueLeft} />
      <Image className={styles.aboutUsIntroOrangeRight} alt="" src={AboutUsIntroOrangeRight} />
      <Image className={styles.aboutUsIntroBottom} alt="" src={AboutUsIntroBottom} />

      {/* Content */}
      <div className={styles.title}>
        <div className={styles.titleLinearGradient}>We are PerksBar.</div>
        <div className={styles.subtitle}>
          We are dedicated to providing a comprehensive and gamified ecosystem that connects
          employees, managers, and organisations.
        </div>
      </div>

      <div className={styles.aboutUsIntroBottomText}>
        <span>{`Perfect blend of \n Creative and Technical.`}</span>
      </div>
    </div>
  </SEOLayout>
);

export default AboutUs;
